module.exports = __webpack_public_path__ + "img/effect1.18b8fbaa.png";